<div [formGroup]="form" class="row form-wrapper">
  @if(!watchers){
    <div class="col-12" [ngClass]="{'col-md-4': !viewMode}">
      <app-select-form-field
        formControlName="caseClosureNotifications"
        [label]="'case.fields.caseClosureNotifications.label' | translate"
        [helpText]="'case.fields.caseClosureNotifications.help'"
        [placeholder]="'placeholders.please_select'"
        [multipleSelect]="true"
        [users]="true"
        [searchable]="true"
        [items]="caseClosureUsers"
        [bindValue]="''"
        [bindLabel]="'fullName'"
        [infoText]="viewMode ? '' : 'label.anyone_in_this_list_will_receive_notification' | translate"
        [customClass]="viewMode ? 'watchers-view' : ''"
        (onSelectEvent)="onChange($event, 'caseClosureNotifications')"
        [externalSearch]="true"
        (onSearchEvent)="searchUsers('search', $event.term, 'caseClosureUsers', $event.page, $event.take)"
        (onScrollEvent)="searchUsers('scroll', $event.term, 'caseClosureUsers', $event.page, $event.take)"
      ></app-select-form-field>
    </div>
    <div class="col-12" [ngClass]="{'col-md-4': !viewMode}">
      <app-select-form-field
          formControlName="allActivityUpdates"
          [label]="'case.fields.allActivityUpdates.label' | translate"
          [helpText]="'case.fields.allActivityUpdates.help'"
          [placeholder]="'placeholders.please_select'"
          [multipleSelect]="true"
          [users]="true"
          [searchable]="true"
          [items]="allActivityUsers"
          [bindValue]="''"
          [bindLabel]="'fullName'"
          [infoText]="viewMode ? '' : 'label.anyone_in_this_list_will_receive_notification' | translate"
          [customClass]="viewMode ? 'watchers-view' : ''"
          (onSelectEvent)="onChange($event, 'allActivityUpdates')"
          [externalSearch]="true"
          (onSearchEvent)="searchUsers('search', $event.term, 'allActivityUsers', $event.page, $event.take)"
          (onScrollEvent)="searchUsers('scroll', $event.term, 'allActivityUsers', $event.page, $event.take)"
        ></app-select-form-field>
    </div>
    <div class="col-12" [ngClass]="{'col-md-4': !viewMode}">
      <app-select-form-field
        formControlName="bookmarkOnly"
        [label]="'case.fields.bookmarkOnly.label' | translate"
        [helpText]="'case.fields.bookmarkOnly.help'"
        [placeholder]="'placeholders.please_select'"
        [multipleSelect]="true"
        [bindValue]="''"
        [bindLabel]="'fullName'"
        [users]="true"
        [searchable]="true"
        [items]="bookmarkOnlyUsers"
        [customClass]="viewMode ? 'watchers-view' : ''"
        (onSelectEvent)="onChange($event, 'bookmarkOnly')"
        [externalSearch]="true"
        (onSearchEvent)="searchUsers('search', $event.term, 'bookmarkOnlyUsers', $event.page, $event.take)"
        (onScrollEvent)="searchUsers('scroll', $event.term, 'bookmarkOnlyUsers', $event.page, $event.take)"
      ></app-select-form-field>
    </div>
  }
  <!-- @if(!viewMode){
    <div class="w-100 d-flex justify-content-between">
      <h5 class="notifications-title">{{ 'label.notifications' | translate }}</h5>
      <app-toggle-switch-form-field
        formControlName="notifications"
      ></app-toggle-switch-form-field>
    </div>
    @if(form.get('notifications').value) {
      <div class="col-12 col-md-2">
        <app-checkbox-form-field
          formControlName="notifySlaBreach"
          [label]="'label.sla_breach' | translate"
          [viewMode]="viewMode"
        ></app-checkbox-form-field>
      </div>
      <div class="col-12 col-md-2">
        <app-checkbox-form-field
          formControlName="notifyStatusChange"
          [label]="'label.status_change' | translate"
          [viewMode]="viewMode"
        ></app-checkbox-form-field>
      </div>
      <div class="col-12 col-md-2">
        <app-checkbox-form-field
          formControlName="notifyComments"
          [label]="'label.comments' | translate"
          [viewMode]="viewMode"
        ></app-checkbox-form-field>
      </div>
      <div class="col-12">
        <app-select-form-field
          formControlName="watchers"
          [placeholder]="'placeholders.please_select'"
          [multipleSelect]="true"
          [users]="true"
          [bindValue]="'id'"
          [bindLabel]="'fullName'"
          [clearable]="true"
          [searchable]="true"
          [items]="users"
          [viewMode]="viewMode"
        ></app-select-form-field>
      </div>
    }
} -->

  @if(viewMode && watchers) {
    <div class="col-12">
      <app-select-form-field
        formControlName="watchers"
        [placeholder]="''"
        [multipleSelect]="true"
        [users]="true"
        [searchable]="true"
        [items]="watchersUsers"
        [customClass]="'watchers-view'"
      ></app-select-form-field>
    </div>
  }
</div>
